// extracted by mini-css-extract-plugin
export default {"content":"style_content__GKFI1","leftSide":"style_leftSide__D01CU","rightSide":"style_rightSide__CF2yR","type":"style_type__ivOSu"};